var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"dashboard-welcome"},[_c('p',[_vm._v(_vm._s(_vm.$t('dashboard.welcome-card.title')))]),_vm._v(" "),(_vm.isLocaleObject(_vm.$t('dashboard.welcome-card.list-ol')))?_c('ol',_vm._l((_vm.$t('dashboard.welcome-card.list-ol')),function(value,i){return _c('li',{key:i},[_vm._v(_vm._s(value))])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b69169e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/welcome.vue
// module id = evTY
// module chunks = 112 119